import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { listaDeInformes, seccionType } from "@/Routes/listaDeInformes";
import { isEmptyObject } from "@/utils/allUtils";
import { IPrecio, informesPrecios } from '@/redux/models';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@/redux/store';
import { plazos } from '@/utils/constants';

interface IRowPrecio {
    name: string,
    componentName: string,
    velocidad: {
        simple?: number,
        urgente?: number,
        express?: number,
        certificada?: number,
        capital?: number,
        provincia?: number,
        precioUnico?: number,
    },
    precio?: number,
}
export type separadorType = {
    Componente: React.FC,
    pos: number
}
export type disabledColsType = 'capital' | 'provincia' | 'certificada' | 'plazoUnico' | 'simple' | 'urgente' | 'express'


const Separador = ({ separador, i }: { separador?: separadorType[], i: number }) => {
    if (!separador || separador.length === 0) return null
    const SeparadorEnPos = separador.find((sep) => sep.pos === i)
    if (SeparadorEnPos) {
        return <TableRow key={'separador' + i}>
            <TableCell colSpan={8} style={{ padding: 0 }}>
                <SeparadorEnPos.Componente />
            </TableCell>
        </TableRow>
    } else return <></>
}

const ComponentsNames = [
    "FormTitularidadDomino",
    "FormEstudioPrefectCapital",
    "FormEstadoParcelarioCapital",
    "FormEstudioPrefectibilidadProvincia",
    "FormEstadoParcelarioProvincia",
    "FormInscripcionOficios",
    "FormInteriorPais",
    "FormPatentamientos",
    "FormTransferencias",
    "FormInformeEscritura"
]

const mensajesPersonalizados: Record<string, Record<string, string>> = {
    "FormTitularidadDomino": { 'simple': 'CONSULTAR PRECIO' },
    "FormEstudioPrefectCapital": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormEstadoParcelarioCapital": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormEstudioPrefectibilidadProvincia": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormEstadoParcelarioProvincia": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormInscripcionOficios": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormPatentamientos": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormTransferencias": { 'plazoUnico': 'CONSULTAR PRECIO' },
    "FormInformeEscritura": { 'certificada': 'CONSULTAR PRECIO' },
    "FormInteriorPais": { 'plazoUnico': 'CONSULTAR PRECIO' },
};






export default function TablaPrecios2({ tipo, precios, separador, disabledCols, tituloExpress = 'Express' }: {
    tipo: 'capital' | 'provincia' | 'catastro' | 'otros',
    precios: IPrecio[],
    separador?: separadorType[]
    disabledCols?: disabledColsType[]
    tituloExpress?: string

}) {
    const theme = useAppSelector(state => state.theme)
    const [rows, setRows] = useState<IRowPrecio[]>([])

    const renderCell = (value: any, componentName: string, nombreColumna: string) => {
        const consultarPrecio = ComponentsNames.includes(componentName);

        if (consultarPrecio && mensajesPersonalizados[componentName]) {
            const mensajeComponente = mensajesPersonalizados[componentName];
            const mensajeColumna = mensajeComponente[nombreColumna];

            if (mensajeColumna) {
                return mensajeColumna;
            }
        }


        return value || value! >= 0
            ? "$" + value
            : <span style={{ fontStyle: 'italic', color: theme.darkTheme ? '#505050' : 'gray' }}>-</span>;
    }


    useEffect(() => {
        const InformesPorTipo = listaDeInformes.filter((informe) => informe.seccion === tipo);

        //recorro los precios que me dieron de la api
        precios.forEach((precio) => {

            let tiposDeInforme: any[] = []
            Object.entries(informesPrecios).forEach(([key, value]) => {
                if (precio.tipo === value) {
                    tiposDeInforme.push(key)
                }
            })

            //busco el informe que tenga el mismo tipo que el precio
            let elInformeConPrecio: any
            InformesPorTipo.map((informe) => Object.entries(informe.tipos).forEach(([key, value]) => {
                if (tiposDeInforme.includes(key)) {
                    elInformeConPrecio = informe
                }
                return
            }))
            if (elInformeConPrecio === undefined) {
                //@ts-ignore
                InformesPorTipo.map((informe) => informe?.tipo && Object.entries(informe?.tipo).forEach(([key, value]) => {
                    if (tiposDeInforme.includes(key)) {
                        elInformeConPrecio = informe
                    }
                    return
                }))
            }



            let velocidades: any = {}
            let preciok: any = undefined
            Object.entries(precio.velocidad).forEach(([key, value]) => {
                if (value === "SIMPLE") {
                    velocidades.simple = precio.precio[0]
                }
                if (value === "URGENTE") {
                    velocidades.urgente = precio.precio[1]
                }
                if (value === "EXPRESS" || value === "EN_EL_DIA") {
                    velocidades.express = precio.precio[2]
                }
                if (value === "CERTIFICADA") {
                    velocidades.certificada = precio.precio[1]
                }
                if (value === "CAPITAL") {
                    velocidades.capital = precio.precio[0]
                }
                if (value === "PROVINCIA") {
                    velocidades.provincia = precio.precio[1]
                }
                if (value === "-1") {
                    velocidades.precioUnico = precio.precio[0]
                }
            })
            if (isEmptyObject(velocidades)) {
                preciok = precio.precio[0]
            }

            if (velocidades !== null && elInformeConPrecio !== undefined) {
                setRows((prev) => [...prev, { name: elInformeConPrecio?.nombre, componentName: elInformeConPrecio?.ComponentName, velocidad: velocidades, precio: preciok }])
            }
        })

    }, [precios])


    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Trámite</TableCell>
                        {
                            !disabledCols?.includes('plazoUnico') &&
                            <TableCell align="center">Plazo Único</TableCell>
                        }
                        {
                            !disabledCols?.includes('simple') &&
                            <TableCell align="center">
                                Simple
                                <p style={{
                                    margin: '0px',
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap'

                                }}>{tipo === 'capital' ? plazos.capital.simple : plazos.provincia.simple}</p>

                            </TableCell>
                        }
                        {
                            !disabledCols?.includes('urgente') &&
                            <TableCell align="center">Urgente
                                <p style={{
                                    margin: '0px',
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap'

                                }}>{tipo === 'capital' ? plazos.capital.urgente : plazos.provincia.urgente}</p>

                            </TableCell>
                        }
                        {
                            !disabledCols?.includes('express') &&
                            <TableCell align="center">{tituloExpress}
                                <p style={{
                                    margin: '0px',
                                    fontWeight: 400,
                                    whiteSpace: 'nowrap'

                                }}>{tipo === 'capital' ? plazos.capital.express : ''}</p>

                            </TableCell>
                        }
                        {
                            !disabledCols?.includes('certificada') &&
                            <TableCell align="center">Certificada</TableCell>
                        }
                        {
                            !disabledCols?.includes('capital') &&
                            <TableCell align="center">Capital</TableCell>
                        }
                        {
                            !disabledCols?.includes('provincia') &&
                            <TableCell align="center">Provincia</TableCell>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, i: number) => {

                        return (
                            <>
                                <Separador separador={separador} i={i} />
                                <TableRow key={row.name + i}>
                                    <TableCell component="th" scope="row" style={{ width: '40%' }}>
                                        {row.name}
                                    </TableCell>
                                    <>
                                        {
                                            !disabledCols?.includes('plazoUnico') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.precioUnico, row.componentName, 'plazoUnico')}
                                            </TableCell>
                                        }
                                        {
                                            !disabledCols?.includes('simple') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.simple, row.componentName, 'simple')}
                                            </TableCell>
                                        }
                                        {
                                            !disabledCols?.includes('urgente') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.urgente, row.componentName, 'urgente')}
                                            </TableCell>
                                        }
                                        {
                                            !disabledCols?.includes('express') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.express, row.componentName, 'express')}
                                            </TableCell>

                                        }
                                        {
                                            !disabledCols?.includes('certificada') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.certificada, row.componentName, 'certificada')}
                                            </TableCell>
                                        }
                                        {
                                            !disabledCols?.includes('capital') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.capital, row.componentName, 'capital')}
                                            </TableCell>
                                        }
                                        {
                                            !disabledCols?.includes('provincia') &&
                                            <TableCell align="center">
                                                {renderCell(row.velocidad.provincia, row.componentName, 'provincia')}
                                            </TableCell>
                                        }

                                    </>
                                </TableRow>
                            </>
                        )
                    })}

                </TableBody>
            </Table>
        </TableContainer >
    );
}